import { FlowbiteService } from './services/flowbite.service';
import { ToastService } from './services/toast.service';
import { ToastComponent, ToastDto } from './shared/ui/toast/toast.component';
import { initFlowbite } from 'flowbite';
import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AnalyticsService } from './services/analytics.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private flowbiteService = inject(FlowbiteService);
  private toastService = inject(ToastService);
  private router = inject(Router);
  public title = 'mesitis-ai-front';

  public toasts = this.toastService.toasts;

  public ngOnInit(): void {
    this.flowbiteService.loadFlowbite(() => initFlowbite());
  }

  public onToastDismissed(id: string): void {
    this.toastService.dismissToast(id);
  }

  public onToastActionClicked(toast: ToastDto): void {
    if (toast.action) {
      this.router.navigate(toast.action.route);
    }

    this.toastService.dismissToast(toast.id);
  }
}
